<template>
  <div>
    <div class="glitchHolder">
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div
          v-for="g in glitches"
          class="glitchOver"
          :style="{marginBottom:g.pad+'px',width:g.width+'%'}"
        >
          <div
            v-for="gc in g.child"
            class="glitchChild"
            :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"
          ></div>
        </div>
      </div>
    </div>

    <div style="width:100%;padding:0% 15%">
      <v-img
        :src="'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/events%2Fskitfaced%2Fskitfaced.jpg?alt=media&token=64833a1d-00d7-45f4-82a7-3fa46ca0e98c'"
        width="100%"
        style="background-"
      ></v-img>
      <div style="display:flex;">
        <div style="width:300px;">
          <b>
            SKITfaced 2020
            <br />curated by Chloe Black
            <br />
            <br />Screening
          </b>

          <br />November 2020
          <br />
          <b>
            <br />**DEADLINE EXTENDED**
            <br />Submissions are now due
            <br />
          </b>
          3pm Monday, 19 October 2020
          <br />
          <br />
          <a
            :href="'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Submission%20Guidelines%20for%20The%20Loop_Jan2020.pdf?alt=media&token=81717957-cc63-496a-b69a-9fddda62e181'"
          >SUBMISSION GUIDELINES</a>
          <br />
          <br />
          <b>Contact</b>
          <br />Chloe Black
          <br />
          <a href="mailto:blackc@hobartcity.com.au">BLACKC@HOBARTCITY.COM.AU​</a>
          <br />City of Hobart - Public Art
          <br />
          <a href="mailto:publicart@hobartcity.com.au">PUBLICART@HOBARTCITY.COM.AU​</a>
          <br />(03) 6238 2100
          <br />
          <br />
          <v-btn to="/participate">SUBMIT CONTENT</v-btn>
          <br />To submit content you need to Sign In or Sign Up via our participate portal
        </div>
        <div style="width:80%;">
          <h2>
            <i>CALL OUT FOR CONTENT</i>
          </h2>
          <div class="EventHeading">
            <b>SKITfaced 2020</b>
          </div>A new film and video comedy program curated by local comedian, Chloe Black for The Loop: A Digital Art Platform for Hobart.
          <br />
          <br />Are you sketchy? Do you make YouTube clips in your spare time? Been making funny faces during Quarantine? Are you a fan of sketch comedy? Do you remember the D-Gen? Fast Forward? The Comedy Company? Even….. *quickly Googles* The Mavis Bramston Show? Then Hobart needs you! To get SKITfaced!
          <br />

          <br />
          <h2>
            WE NEED YOU!!
            <br />TO BE FUNNY!!.
          </h2>
          <br />That’s right. YOU. The person reading this! We’re looking for quick, fast, and bite- sized delights of comedy content to be screened at The Hobart Loop on Elizabeth Street. There’s even a $1000 cash prize for the best one submitted. Other prize categories include Best Ensemble, Best Solo, Best Youth, and People’s Choice!
          <b>
            <br />
            <br />
            <h2>Great! What do I do?</h2>
          </b>
          Send us your content!
          <br />

          <br />
          <h2>Yes please. What can I submit?</h2>Videos can be any length up to a maximum of 5 minutes.
          <br />

          <p>
            Just remember; clips have to be suitable for public broadcast (no nudity, or swears
            or hateful content) and suitably subtitled (it&#39;s a public space, there are neighbours
            and we have to abide by public noise regulations). But apart from that, have at it!
          </p>

          <h2>Video Formats</h2>
          <p>
            Videos need to be uploaded via The Loop’s submission portal.
            The platform accepts .mpeg4, H.264 and files no larger than 4Gb. You’ll also be
            asked to submit a brief description of your content and a key image.
            Videos need to be a maximum of 5 minutes long.
            Output resolution for the Loop’s screen is 960 x 576.
            For more information on formatting and the screen download The Loop’s Submission
            Guidelines.
            <v-btn
              :href="'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Submission%20Guidelines%20for%20The%20Loop_Jan2020.pdf?alt=media&token=81717957-cc63-496a-b69a-9fddda62e181'"
            >
              <v-icon>description</v-icon>&nbsp;Submission
              Guidelines
            </v-btn>
          </p>
          <h2>How do I submit?</h2>
          <p>
            You can upload your final video for consideration through The Loop’s online
            submission portal at The Loops
            <v-btn to="/participate">participate</v-btn>page. Once you submit, we’ll be in
            touch with you! You can also send us a URL if you’re video is online (ie: Youtube,
            TikTok or Vimeo).
          </p>
          <h2>Help!</h2>
          <p>
            If you’re having trouble with formatting, captioning, uploading your content or if you
            need to check if your content is suitable, please contact the City’s Public Art team by
            emailing
            <v-btn :href="'mailto:publicart@hobartcity.com.au'">publicart@hobartcity.com.au​</v-btn>or call (03) 6238 2565.
            <br />Alternatively, email
            program curator, Chloe Black,
            <v-btn :href="'mailto:blackc@hobartcity.com.au'">blackc@hobartcity.com.au​</v-btn>
          </p>
          <h2>Notification</h2>
          <p>
            We’ll be in touch after you submit. Announcement of successful submissions will be
            in early November 2020.
          </p>

          <h2>Competition and Prizes</h2>
          <p>
            It’s been a tough time for Hobart’s comedy scene during Covid-19, so we’re
            rewarding your efforts and talent! There will be a competition element including a
            $1000 price for Best Featured Skit. Other categories include: Best Youth Entry; Best
            Solo; and Best Ensemble. Also The People’s Choice! All selected content will be
            given the Official Laurel to be placed on their CV and future promotions.
            The program of content will be curated by Chloe Black. Prizes will be awarded by a
            judging panel, including notable comedians. Prizes will be announced at the launch
            event in November 2020.
            <br />
            <br />Superstar judging panel to be announced shortly!
          </p>

          <h2>Screening Dates</h2>
          <p>
            Skitfaced 2020 will be launched with a public screening event in November 2020 and
            will screen in November –December 2020 on The Loop.
            Follow
            <v-btn :href="'https://www.instagram.com/skitfacedhobart/'">&nbsp;@skitfacedhobart</v-btn>on Instagram to view and vote for your favourite skits in
            November!
          </p>
          <div v-if="!userIsAuthenticated">
            <b>You need an account to sumbit your comedy.</b>
            <v-btn to="/signin">
              <v-icon left>lock_open</v-icon>Sign In
            </v-btn>
            <v-btn to="/signup">
              <v-icon left>face</v-icon>Sign Up
            </v-btn>
          </div>
          <div v-if="userIsAuthenticated" style="text-align:center">
            <v-btn to="/content/new">
              <v-icon>movie</v-icon>&nbsp;Submit your comedy here.
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0,
    };
  },
  mounted() {
    this.glitches = [];
    let childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({
        colour: "#00000044",
        height: 30,
        pad: 3,
        width: Math.random() * 50 + 50,
        child: childA,
      });
    }
    setTimeout(this.glitch, 100);
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
  },
  methods: {
    glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    },
  },
};
</script>

<style scoped>
.glitchHolder {
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;
  min-height: 100px;
  overflow: hidden;
  pointer-events: none;
}
#glitchOverlay {
  position: absolute;
  left: -100px;
  top: 0px;
}
.glitchOver {
  z-index: 3;
  position: relative;
  min-height: 30px;
  pointer-events: none;
  opacity: 0.3;
  width: 400px;
}
.glitchChild {
  width: 40px;
  display: inline-block;
  background-color: #00f;
}

.lhColumn {
  position: relative;
  width: 50%;
}
.rhColumn {
  position: relative;
  width: 50%;
  padding: 10px;
}
.EventHeading {
  font-size: 24px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Skitfaced.vue